const DEFAULT_ITEM = {
  title: 'Другое',
  name: 'Другое',
  cost_value: '0.00',
  cost_currency: 'RUB',
  quantity: 1,
  count: 1,
  pickup_point: 0,
}

export function makeDummyItems(route: {type: string; coordinates?: [number, number]; uri?: string}[]) {
  /**
   * при запросах в форму грузового количество и индексы айтемов проверяются прайсингом и клеймами,
   * но юзер нигде не имеет возможности заполнить эти поля.
   * Поэтому список айтемов заполняем дамми-объектами
   * */
  const length = route.filter(routePoint => routePoint.type === 'destination').length
  const array = []

  for (let i = 0; i < length; i++) {
    array.push(Object.assign({}, DEFAULT_ITEM, {droppof_point: i + 1, dropoff_point: i + 1}))
  }

  return array
}
